<template>
    <component :is="tag" :class="style" class="btn" :disabled="disabled">
        
        <span><slot></slot></span>
    </component>
</template>
<script>
    export default {
        props: {
            type:{
                default: function () {
                    return 'normal'
                }
            },
            tag: {
                type: String,
                default: 'button'
            },
            size:  {
                type: String,
                default: 'normal' // варианты: small
            },
        },
        computed: {
            disabled(){
                return (this.type != 'normal');
            },
            style(){
                if(this.type == 'load'){
                    return 'btn--preloader '+(this.size === 'small'?'size-s':'');
                }
                if(this.type == 'ok'){
                    return 'btn--preloader --ok '+(this.size === 'small'?'size-s':'');
                }
            }
        },
        methods:{
            send: function(){
            }
        }
    }
</script>
